// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2N7MI","left":"StickyBox_left__2wA5_","right":"StickyBox_right__3P8bN"};